module.exports = __webpack_public_path__ + "assets/img/00141.8a7e2a13.png";